import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchCategory = () => {
  return Api(endPoints.fetchCategory, null, requestType.GET);
};

export const createCategory = (params) => {
  return Api(endPoints.createCategory, params, requestType.POST);
};
